<template>
  <DrawRule />
</template>

<script>
import DrawRule from "@/components/place/drawactivity/DrawRule.vue";
export default {
  data() {
    return {};
  },
  components: {
    DrawRule,
  },
};
</script>
<style lang="" scoped></style>
